// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".point[data-v-fe3c5698]{background:#ec8ab3;border:1px solid #fff;width:10px;height:10px;position:absolute;border-radius:100px;transform:translate(-50%,-50%);cursor:move}.point .point__inputs[data-v-fe3c5698]{margin:10px;width:100px}.point .point__inputs--item[data-v-fe3c5698]{width:100%}", ""]);
// Exports
module.exports = exports;
